module.exports = __webpack_public_path__ + "img/c87b1a7b5b48e90295c210b4d40ee058_副本.789e9755.jpg";